import { render, staticRenderFns } from "./xMenu.vue?vue&type=template&id=7ededa87&scoped=true&"
import script from "./xMenu.vue?vue&type=script&lang=js&"
export * from "./xMenu.vue?vue&type=script&lang=js&"
import style0 from "./xMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./xMenu.vue?vue&type=style&index=1&id=7ededa87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ededa87",
  null
  
)

export default component.exports